<script>
    import { onMount } from "svelte";
    import { navigateTo } from "svelte-router-spa";
    import { PRConnect } from "@projectroom/ui-lib";
    import Payment from "../components/Payment.svelte";

    let token;
    let paymentComponent;

    onMount(() => {
        token = PRConnect.getCookie("x-token");
    });

    const handlePaidPlan = (authType) => {
        if (!token) {
            navigateTo("/join");
            return;
        }
        const currency =
            Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Seoul"
                ? "KRW"
                : "USD";
        PRConnect.send(
            "/api/Payment/getPlanPriceInfo",
            { authType, currency },
            (data) => {
                if (data.header.status === "success") {
                    const price = data.result.amount;
                    const resolvedAuthType = data.result.authType;
                    paymentComponent.showPopup(
                        price,
                        resolvedAuthType,
                        true,
                        currency,
                    );
                }
            },
        );
    };

    const handleFree = () => {
        if (!token) {
            navigateTo("/join");
        } else {
            navigateTo("/main");
        }
    };

    const handleEnterprise = () => {
        // 기존: 구글 폼 문의 (https://docs.google.com/forms/d/e/1FAIpQLSevt97eEa3gJl0_oqTeV5OqsyU5CLVhrvYIymm5QR_mnDd-TQ/viewform)
        window.open("https://www.groovworks.com/contactus", "_blank");
    };
</script>

<div class="pricing-page">
    <div class="event-title">
        <div class="e-title">
            <strong class="bold-text-7">아바톡 요금제</strong>
        </div>
    </div>

    <div class="plans-container">
        <div class="e-sub">
            미니 페이지부터 AI챗 제작까지, 아바톡 하나로 시작하세요!
        </div>
        <!-- FREE -->
        <div class="plan-card">
            <div class="plan-top">
                <div class="plan-name">Free</div>
                <div class="plan-desc">
                    나만의 미니 페이지 제작,<br />가볍게 시작해보세요!
                </div>
                <div class="plan-price">
                    <span class="price-amount">0</span>원/월
                </div>
            </div>
            <div class="plan-features">
                <div class="feature-section-title">미니 페이지 제작</div>
                <ul>
                    <li>1개의 미니 페이지 제작</li>
                    <li>3개의 메인 섹션 구성</li>
                    <li>로고 이미지 업로드 가능</li>
                    <li>기본 디자인 스타일 사용</li>
                    <li>기본 템플릿 사용 가능</li>
                </ul>
            </div>
            <button class="plan-btn btn-free" on:click={handleFree}
                >무료로 시작하기</button
            >
        </div>

        <!-- STARTER -->
        <div class="plan-card">
            <div class="plan-top">
                <div class="plan-name">Starter</div>
                <div class="plan-desc">
                    미니 페이지와 AI챗 제작,<br />기본 기능으로 시작해보세요!
                </div>
                <div class="plan-price">
                    <span class="price-amount">14,900</span>원/월
                </div>
            </div>
            <div class="plan-features">
                <div class="feature-inherit">Free의 모든 기능 및+</div>
                <div class="feature-section-title">미니 페이지 제작</div>
                <ul>
                    <li>1개의 미니 페이지 제작</li>
                    <li>제한없는 메인 섹션 구성</li>
                    <li>아바톡 로고 제거 가능</li>
                    <li>질의응답/개인정보 입력폼 기능 제공</li>
                    <li>공유 버튼 활성화 가능</li>
                    <li>다양한 디자인 스타일 사용</li>
                    <li>모든 템플릿 사용 가능</li>
                </ul>
                <div class="feature-section-title ai">✦ AI챗 제작</div>
                <ul>
                    <li>1개의 AI챗 생성</li>
                    <li>월 500건 AI 응답 제공</li>
                    <li>월 30개의 이미지 생성 가능</li>
                </ul>
            </div>
            <button
                class="plan-btn btn-paid"
                on:click={() => handlePaidPlan("STARTER")}>시작하기</button
            >
        </div>

        <!-- PRO -->
        <div class="plan-card plan-card-recommended plan-card-featured">
            <div class="recommend-badge">추천</div>
            <div class="plan-top">
                <div class="plan-name">Pro</div>
                <div class="plan-desc">
                    미니 페이지와 AI챗 운영,<br />다양하고 자유롭게
                    확장해보세요!
                </div>
                <div class="plan-price">
                    <span class="price-amount">24,900</span>원/월
                </div>
            </div>
            <div class="plan-features">
                <div class="feature-inherit">Starter의 모든 기능 및+</div>
                <div class="feature-section-title">미니 페이지 제작</div>
                <ul>
                    <li>3개의 미니 페이지 제작</li>
                    <li>통계 대시보드 제공</li>
                    <li>링크 프리뷰 커스텀 기능 제공</li>
                    <li>URL 커스텀 기능 제공</li>
                    <li>구글 애널리틱스 연동 가능</li>
                </ul>
                <div class="feature-section-title ai">✦ AI챗 제작</div>
                <ul>
                    <li>3개의 AI챗 생성</li>
                    <li>월 1,000건 AI 응답 제공</li>
                    <li>월 50개의 이미지 생성 가능</li>
                </ul>
            </div>
            <button
                class="plan-btn btn-paid"
                on:click={() => handlePaidPlan("PRO")}>시작하기</button
            >
        </div>

        <!-- ENTERPRISE -->
        <div class="plan-card">
            <div class="plan-top">
                <div class="plan-name">Enterprise</div>
                <div class="plan-desc">
                    여러 건의 구축과 별도 커스텀이 필요한<br />기업/팀을 위한
                    맞춤형 플랜이에요!
                </div>
                <div class="plan-price enterprise-price">별도 문의</div>
            </div>
            <div class="plan-features">
                <ul>
                    <li>여러 건의 구축</li>
                    <li>별도 커스텀 협의</li>
                    <li>우선순위 CS 지원</li>
                </ul>
            </div>
            <button class="plan-btn btn-paid" on:click={handleEnterprise}
                >문의하기</button
            >
        </div>
    </div>
</div>

<Payment bind:this={paymentComponent} />

<style>
    .pricing-page {
        max-width: 1400px;
        margin: 0 auto;
        margin-top: 110px;
        font-family: "Noto Sans KR", sans-serif;
        min-height: calc(100vh - 280px);
        padding-left: 20px;
        padding-right: 20px;
    }

    .event-title {
        margin: auto;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 16px;
    }

    .e-sub {
        width: 100%;
        font-size: 15px;
        font-weight: 500;
        color: #666;
        text-align: center;
        padding: 20px;
        margin-bottom: 0px;
    }

    .plans-container {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: stretch;
        justify-content: center;
        padding: 0 40px;
    }

    .plan-card {
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        padding: 24px 20px;
        flex: 1;
        min-width: 200px;
        max-width: 260px;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .plan-card-recommended {
        border: 2px solid #e0e0e0;
    }

    .plan-card-featured {
        border: 2px solid #e55e8a;
        background: linear-gradient(180deg, #ffd0e696 0%, #fff5f882 5%);
        box-shadow: 3px 3px 8px 0 rgba(229, 94, 138, 0.15);
    }

    .recommend-badge {
        position: absolute;
        top: 14px;
        right: 14px;
        background: #e55e8a;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 10px;
    }

    .plan-top {
        margin-bottom: 20px;
    }

    .plan-name {
        font-size: 22px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 8px;
        text-align: center;
    }

    .plan-desc {
        font-size: 12px;
        color: #555;
        text-align: center;
        line-height: 1.5;
        margin-bottom: 16px;
    }

    .plan-price {
        font-size: 22px;
        font-weight: 700;
        color: #1a1a1a;
        text-align: center;
    }

    .price-amount {
        font-size: 24px;
        font-weight: 700;
    }

    .allinone-price {
        font-size: 16px;
        line-height: 1.6;
    }

    .price-sub {
        font-size: 11px;
        font-weight: 400;
        color: #666;
    }

    .enterprise-price {
        font-size: 20px;
    }

    .plan-features {
        flex: 1;
        margin-bottom: 20px;
    }

    .feature-inherit {
        font-size: 13px;
        font-weight: 700;
        color: #333;
        margin-bottom: 10px;
    }

    .feature-section-title {
        font-size: 13px;
        font-weight: 700;
        color: #e55e8a;
        margin-top: 12px;
        margin-bottom: 6px;
    }

    .feature-section-title.ai {
        color: #e55e8a;
    }

    .plan-features ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .plan-features ul li {
        font-size: 13px;
        color: #444;
        padding: 3px 0 3px 16px;
        position: relative;
        line-height: 1.5;
    }

    .plan-features ul li::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #666;
    }

    .plan-btn {
        width: 100%;
        padding: 12px 0;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        font-family: "Noto Sans KR", sans-serif;
        transition: opacity 0.15s;
    }

    .plan-btn:hover {
        opacity: 0.85;
    }

    .btn-paid {
        background-color: #e55e8a;
        color: #fff;
    }

    .btn-free {
        background-color: #4a4a5a;
        color: #fff;
    }
    @media screen and (max-width: 1280px) {
        .pricing-page {
            margin-top: 100px;
        }
    }
    @media screen and (max-width: 1100px) {
        .plans-container {
            flex-wrap: wrap;
            gap: 20px;
        }
        .plan-card {
            min-width: 240px;
            max-width: 280px;
        }
    }

    @media screen and (max-width: 767px) {
        .plans-container {
            flex-direction: column;
            padding: 0 20px;
        }
        .plan-card {
            width: 100%;
            max-width: 100%;
        }
        .pricing-page {
            margin-top: 76px;
        }
    }

    @media screen and (max-width: 479px) {
        .e-title {
            font-size: 20px;
        }

        .pricing-page {
            margin-top: 66px;
        }
    }
</style>
